<h4 class="mb-2">Shadow Settings</h4>
<h6 class="mb-1">Default Shadow Staffs</h6>
<table class="table">
  <thead>
    <tr>
      <th>Company</th>
      <th>Bureau</th>
      <th>Shadow Staff</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let shadow of defaultShadowStaffs; index as i">
      <td>
        <ng-template [ngIf]="shadow.company_id">
          <ng-template ngFor let-company [ngForOf]="companies">
            <ng-template [ngIf]="shadow.company_id == company.id">
              {{company.name}}
            </ng-template>
          </ng-template>
        </ng-template>
        <ng-template [ngIf]="!shadow.company_id">
          Default
        </ng-template>
      </td>
      <td>
        <ng-template ngFor let-company [ngForOf]="companies">
          <ng-template ngFor let-bureau [ngForOf]="company.bureaus">
            <ng-template [ngIf]="shadow.company_id == company.id && shadow.bureau_id == bureau.id">
              {{bureau.name}}
            </ng-template>
          </ng-template>
        </ng-template>
      </td>
      <td>{{ staffById[shadow.shadow_id] | fullName }}</td>
      <td>
        <button bkButton color="danger" (click)="onDeleteStaffShadow(i)">
          <i class="fa fa-trash"></i>
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <select name="company_id" class="form-control" bkInput [(ngModel)]="newStaffShadow.company_id">
          <option value="">Default</option>
          <option [value]="company.id" *ngFor="let company of companies">{{company.name}}</option>
        </select>
      </td>
      <td>
        <select name="bureau_id" class="form-control" bkInput [(ngModel)]="newStaffShadow.bureau_id">
          <ng-template ngFor let-company [ngForOf]="companies">
            <ng-template [ngIf]="newStaffShadow.company_id == company.id">
              <option [value]="bureau.id" *ngFor="let bureau of company.bureaus">
                {{bureau.name}}
              </option>
            </ng-template>
          </ng-template>
        </select>
      </td>
      <td>
        <ng-select name="shadow_id" [items]="staffs || []" bindValue="id" [(ngModel)]="newStaffShadow.shadow_id"
          [virtualScroll]="true" [searchFn]="matchStaff" placeholder="Shadow Staff">
          <ng-template ng-label-tmp let-item="item">{{ item | fullName }}</ng-template>
          <ng-template ng-option-tmp let-item="item">{{ item | fullName }}</ng-template>
        </ng-select>
      </td>
      <td>
        <button bkButton color="secondary" type="button" (click)="onAddStaffShadow()">
          <i class="fa fa-plus"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>
<h6 class="mb-1">Shadow Schedules</h6>
<table class="table">
  <thead>
    <tr>
      <th>From</th>
      <th>To</th>
      <th></th>
    </tr>
  </thead>
  <tbody>
    <tr *ngFor="let shadow_schedule of shadowSchedules; index as i">
      <td>
        {{shadow_schedule.start_at | date: 'MM/dd/yyyy'}}
      </td>
      <td>
        {{shadow_schedule.end_at | date: 'MM/dd/yyyy'}}
      </td>
      <td>
        <button bkButton color="danger" (click)="onDeleteShadowSchedule(i)">
          <i class="fa fa-trash"></i>
        </button>
      </td>
    </tr>
    <tr>
      <td>
        <input type="text" name="start_at" [(ngModel)]="newShadowSchedule.start_at" class="form-control datetimepicker" bkInput
          placeholder="From" autocomplete="off" bsDatepicker [bsConfig]="{ adaptivePosition: true }">
      </td>
      <td>
        <input type="text" name="end_at" [(ngModel)]="newShadowSchedule.end_at" class="form-control datetimepicker" bkInput
          placeholder="To" autocomplete="off" bsDatepicker [bsConfig]="{ adaptivePosition: true }">
      </td>
      <td>
        <button bkButton color="secondary" type="button" (click)="onAddShadowSchedule()">
          <i class="fa fa-plus"></i>
        </button>
      </td>
    </tr>
  </tbody>
</table>